module.exports = __webpack_public_path__ + "static/media/se_1.0ae2cfb8.ogg";